export enum TimeWindow {
  Last24Hours = '24h',
  Last7Days = '7d',
  Last30Days = '30d',
  Last90Days = '90d',
  AllTime = 'all',
}
